import ReactDOM from "react-dom/client";
import { App } from "./_sources/autocomplete-demo/Root.tsx";

const mountElement = document.getElementById("autocomplete-demo");

if (mountElement) {
  mountElement.textContent = "";
  ReactDOM.createRoot(mountElement).render(<App />);
}
